import * as firebase from 'firebase'
import {tidyMap} from "../helpers.js"
import {tidyLoc} from "../helpers.js"

import Vue from "vue"
import { ColorKeyframeTrack } from 'three'



export default {
  state: {
    currentMap:null,
      maps:[

      ],
      zones:[
        {id:"zne001",size:4000,lat:-12.2701913,lng:136.8224376,col:"orange", name: "Departed: some airport",selected:true},
        {id:"zne002",size:630,lat:-400,lng:1790,col:"red", name: "Radio 2: On route leaving the coast ",selected:true},
        {id:"zne003",size:5000,lat:-12.2701913,lng:136.8224376,col:"orange",name: "Radio 2: Over coast near a place - (engine trouble)",selected:true},
        {id:"zne004",size:1000,lng:960,lat:600,col:"red",name: "Radio 3: Over coast near another place - (turning back)",selected:true},
        {id:"zne005",size:1250,lng:460,lat:50,col:"yellow",name: "Radio 4: just off shore - (Mayday)",selected:true},
       
      ],
      locations:[],
      mapArea:null,
      },
  mutations: {
    setMapArea(state,payload){ 
      //console.log("MAP AREA SET")
      state.mapArea=payload
    },
    setCurrentMap(state,payload){
      state.currentMap=payload
    },
    setLocation(state,payload){
      let found=false
      for(var i in state.locations ){
        if(state.locations[i].id==payload.id){
          found=true
          Vue.set(state.locations,i,payload.content)
          //state.maps[i]=payload.content
        } 
      }
      if(!found){
        state.locations.push(payload.content)
      }
    },
    addMapList(state,payload){
      console.log("Add Map",payload)
      var found=false;
      for(var i in state.maps ){
        if(state.maps[i].id==payload.id){
          found=true
        } 
      }
      if(!found){
        state.maps.push(payload.content)
      }
    },
    setMap(state,payload){
      var found=false;
      for(var i in state.maps ){
        if(state.maps[i].id==payload.id){
          found=true
         
          Vue.set(state.maps,i,payload.content)
          state.maps[i]=payload.content
        } 
      }
      if(!found){
        state.maps.push(payload.content)
      }
    },
  },
  actions: {
    loadMapList({commit,state}){
      let docs
      let doc
      let data
      var db = firebase.firestore();
      var colRef = db.collection("Maps")
      colRef.get().then(function(col) {
       docs=col.docs
       console.log("LOAD MAP LIST",docs)
        for(var d in docs){
          doc=docs[d]
          data=docs[d].data()
          data.id=doc.id
          console.log("MAP LIST",doc.id)
          commit('setMap',{id:doc.id,content:tidyMap(data)}) 
        }
      }).catch(function(error) {
        console.log("Error getting document:", error);
        commit('loadingText',false)
      });
    },
    
    async retreiveLocation({commit,getters},payload){
      if(getters.getLocation(payload)){
        return getters.getLocation(payload)
      }
     commit('loadingText',true)
    let data
    var db = firebase.firestore();
    let tidy
    var docRef =  db.collection("Locations").doc(payload)
    await docRef.get().then(function(doc) {
      data=doc.data()
      data.id=payload
      tidy={id:payload,content:tidyLoc(data)}
        commit('loadingText',false)
        commit('setLocation',tidy) 
        return tidy

    }).catch(function(error) {
        console.log("Error getting document:", error);
        commit('loadingText',false)
      });
    },
    async loadMap({ commit },payload){
      console.log("DO LOAD",payload)
      let data
      let tidy
      var db = firebase.firestore();
      var docRef = db.collection("Maps").doc(payload)
      await docRef.get().then(function(doc) {
        data=doc.data()
        data.id=payload
        tidy={id:payload,content:tidyMap(data)}
        console.log("LOADED MAP",data)
          commit('loadingText',false)
          commit('setMap',tidy) 
          return tidy
          //commit('setCurrentMap',payload) 
      }).catch(function(error) {
          console.log("Error getting document:", error);
          commit('loadingText',false)
        });
    },
    loadLoc({ commit,getters },payload){
        if(getters.getLocation(payload)){
          return
        }
       
      commit('loadingText',true)
      let data
      var db = firebase.firestore();
      var docRef = db.collection("Locations").doc(payload)
      docRef.get().then(function(doc) {
        data=doc.data()
        data.id=payload
          commit('loadingText',false)
          commit('setLocation',{id:payload,content:tidyLoc(data)}) 
      }).catch(function(error) {
          console.log("Error getting document:", error);
          commit('loadingText',false)
        });
    }
  },
  getters: {
    getMapArea(state){
      console.log("STATE",state)
      if(state.getWreck){
        console.log("Wave wreck",state.getWreck)
      

      }
      return state.mapArea
    },
    getMap: state => id => {
        for(var map in state.maps){
            if(state.maps[map].id==id){
                return state.maps[map]
            }
        }
        return null
    },
    getMaps(state){
      return state.maps
    },
    getCurrentMap(state){ 
      for(var map in state.maps){
        if(state.maps[map].id==state.currentMap){
          //alert("GET MAP "+state.currentMap)
            return state.maps[map]
        }
    }
    return null
    },
    getMapZones: state => id => {
      var zones=[]
      console.log("GET MAP ZONE",id, state.maps)
      for(var map in state.maps){
        if(state.maps[map].id==id){
            for(var zone in state.maps[map].zones){
              
             // if(state.maps[map].zones.includes(state.zones[zone].id)){
                  zones.push(state.zones[zone])
             // }
          }
        }
    }
      return zones
  },
    getZone: state => id => {
      for(var zone in state.zones){
          if(state.zones[zone].id==id){
              return state.zones[zone]
          }
      }
      return null
  },
  getLocation: state => id => {
    for(var location in state.locations){
        if(state.locations[location].id==id){
            return state.locations[location]
        }
        
    }
    return null
},
  getZones(state){
    return state.zones
  }
  }
}

